import './Header.scss';
import { useEffect } from 'react';
import ScrollMagic from 'scrollmagic';
import { ReactComponent as BerryLogo } from '../../assets/imagen/logos/logofull.svg';
import Menu from './menu/Menu';

function Header() {
  useEffect(() => {
    const controller = new ScrollMagic.Controller();
    // build scene
    new ScrollMagic.Scene({ triggerElement: '#trigger1', triggerHook: 'onLeave' })
      // trigger animation by adding a css class
      .setClassToggle('#menu-logo-container', 'hide-logo')
      .addTo(controller);
  }, []);

  return (
    <div>
      <div id="trigger0" />
      <div id="menu-logo-container">
        <BerryLogo></BerryLogo>
      </div>
      <div className="main-menu"></div>
      <div id="trigger1" />
      <Menu />
    </div>
  );
}

export default Header;
